module.exports = __webpack_public_path__ + "img/grassi2.0e314278.jpg";